module.exports = __webpack_public_path__ + "static/img/result_ls_ceil.5f3b98a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_ls_ceil.jpg
// module id = g7So
// module chunks = 3